/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. GTAAAACGACGGCCAGT`)
};

const es_tm_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p. ej. GTAAAACGACGGCCAGT`)
};

const de_tm_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. GTAAAACGACGGCCAGT`)
};

const nl_tm_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. GTAAAACGACGGCCAGT`)
};

const fr_tm_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. GTAAAACGACGGCCAGT`)
};

const it_tm_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. GTAAAACGACGGCCAGT`)
};

const pt_br2_tm_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex.: GTAAAACGACGGCCAGT`)
};

const pt_tm_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por ex. GTAAAACGACGGCCAGT`)
};

const ja_tm_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: GTAAAACGACGGCCAGT`)
};

const zh_tm_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如 GTAAAACGACGGCCAGT`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_input_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_input_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_input_placeholder", locale)
	if (locale === "en") return en_tm_input_placeholder(inputs)
	if (locale === "es") return es_tm_input_placeholder(inputs)
	if (locale === "de") return de_tm_input_placeholder(inputs)
	if (locale === "nl") return nl_tm_input_placeholder(inputs)
	if (locale === "fr") return fr_tm_input_placeholder(inputs)
	if (locale === "it") return it_tm_input_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_tm_input_placeholder(inputs)
	if (locale === "pt") return pt_tm_input_placeholder(inputs)
	if (locale === "ja") return ja_tm_input_placeholder(inputs)
	return zh_tm_input_placeholder(inputs)
};